"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
exports.default = (0, react_intl_1.defineMessages)({
    msgGitCommitModal: {
        id: 'git.commit.modal',
        defaultMessage: 'Git Add & Commit Modal',
    },
    msgGitCommitModalClose: {
        id: 'git.commit.modal.close',
        defaultMessage: 'Close Dialog',
    },
    msgGitCommitMessage: {
        id: 'git.commit.message',
        defaultMessage: 'Commit Message',
    },
});
//# sourceMappingURL=repository.js.map